import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-filter-status-badge',
  templateUrl: './filter-status-badge.component.html',
  styleUrls: ['./filter-status-badge.component.scss']
})
export class FilterStatusBadgeComponent {
  @Input() isVisible: boolean = false;
  @Input() filterCount: number = 0;

  constructor() {}
}